import React from 'react';
import { formatStatus, getStatusColorClass } from '../../utils/formatters';
import { CheckCircleIcon, ClockIcon, XCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useAdminTheme } from '../../contexts/AdminThemeContext';

const StatusBadge = ({ status, showIcon = false }) => {
  const { isDarkMode } = useAdminTheme();
  
  const getStatusIcon = (status) => {
    const iconClasses = isDarkMode 
      ? {
          pending: 'w-4 h-4 text-yellow-400',
          pending_approval: 'w-4 h-4 text-orange-400',
          paid: 'w-4 h-4 text-green-400',
          failed: 'w-4 h-4 text-red-400',
          expired: 'w-4 h-4 text-red-400',
          default: 'w-4 h-4 text-gray-400'
        }
      : {
          pending: 'w-4 h-4 text-yellow-600',
          pending_approval: 'w-4 h-4 text-orange-600',
          paid: 'w-4 h-4 text-green-600',
          failed: 'w-4 h-4 text-red-600',
          expired: 'w-4 h-4 text-red-600',
          default: 'w-4 h-4 text-gray-600'
        };
    
    const iconClass = iconClasses[status] || iconClasses.default;
    
    switch (status) {
      case 'pending':
        return <ClockIcon className={iconClass} />;
      case 'pending_approval':
        return <ExclamationTriangleIcon className={iconClass} />;
      case 'paid':
        return <CheckCircleIcon className={iconClass} />;
      case 'failed':
        return <XCircleIcon className={iconClass} />;
      case 'expired':
        return <ExclamationTriangleIcon className={iconClass} />;
      default:
        return <ExclamationTriangleIcon className={iconClass} />;
    }
  };

  return (
    <span className={`${getStatusColorClass(status, isDarkMode)} inline-flex items-center`}>
      {showIcon && (
        <span className="mr-1" role="img" aria-label={status}>
          {getStatusIcon(status)}
        </span>
      )}
      {formatStatus(status)}
    </span>
  );
};

export default StatusBadge;
